const SAFE_PROTOCOLS = ["http:", "https:"];

/** True when a URL is safe to put in an href or hand to window.open. Rejects javascript:, data: and every other non-web scheme. */
export function isSafeExternalUrl(url: string | null | undefined): url is string {
  if (!url) return false;

  try {
    return SAFE_PROTOCOLS.includes(new URL(url, window.location.origin).protocol);
  } catch {
    return false;
  }
}

/** Open an external URL in a new tab without giving it access to the opener. Does nothing when the URL is unsafe. */
export function openExternalUrl(url: string | null | undefined): void {
  if (!isSafeExternalUrl(url)) return;

  window.open(url, "_blank", "noopener,noreferrer");
}
